import {enConfig} from './en';

export const frConfig = {
    ...enConfig.base,
    bismi:'Au nom de Dieu, le Tout Miséricordieux, le Très Miséricordieux.',
    salaam:'Salaam',
    header:{
        signup : "Inscription",
        signin : "Connection",    
        signout : "Sortie",
        close: "Fermer",
        profile: "Profil",
        email: "E-mail",
        phone: "Téléphone",
        about : "À propos",
        article : "Articles",
        contact : "Contact",
        download: "Télécharger",
        joinus : "Rejoignez-nous"
    },
    
    home:{
        title : 'Digitalisation',
        about: 'Nous visons à initier la nouvelle génération aux métiers du numérique et aux langages de programmation, en particulier Python et JavaScript',
        connected: 'Vous devez être inscrit'
    },

    profile:{
        ...enConfig.profile,
        salaam :'Salut, ',
        setting:'Paramètres',
        contact:'Contact',
        logout:'Déconnexion',
        site:'Site',
        profile:'Profil',
        home:'Accueil',
        contact:'Contact',
        order:'Commande',
        invoice:'Factures',
    },

    blog: {
        ...enConfig.blog,
        title :'Articles les plus intéressants',
    },

    contact:{
        title:'Contactez-nous',
        message:'Veuillez remplir le formulaire ci-dessous pour nous envoyer un e-mail',
        confirm:'Confirmation de contact',
        content:'Veuillez remplir le code que nous vous avons envoyé par e-mail pour le confirmer',
        recipient:"Veuillez confirmer les informations du destinataire.",
        feedback : 'Nous avons reçu votre message, nous vous contacterons dès que possible',
        warning : "Vous devez confirmer votre e-mail avant de continuer"
    },
    
    getApp : {
        name : 'Télécharger ServicesApp',
        info : 'Télécharger Services App'
    },

}
